import React, { useEffect } from 'react'
import { isEmpty } from 'lodash/lang'
import Masonry from 'react-responsive-masonry'
import styles from '../UserCard.module.scss'
import VisaItem from './VisaItem/VisaItem'
import { setVisasInfo } from '../../../redux/actions/userCard.action'
import { useDispatch } from 'react-redux'
import { ReactComponent as NoInfoImage } from '../../../assets/images/visas_stub.svg'
import { useMediaQuery } from '@mui/material'

const Visas = ({ userCardData }) => {
  const dispatch = useDispatch()
  const isOneColumn = useMediaQuery('(max-width:767.98px)')
  const { visas } = userCardData
  useEffect(() => {
    return () => {
      dispatch(setVisasInfo([]))
    }
  }, [dispatch])
  if (isEmpty(visas)) {
    return (
      <div className={styles.noInfo}>
        <NoInfoImage width={isOneColumn ? '100%' : 400} height={isOneColumn ? 'auto' : 260} />
        <p>You don’t have any visas yet. </p>
      </div>
    )
  } else {
    return (
      <Masonry columnsCount={isOneColumn ? 1 : 2} gutter='16px'>
        {visas?.map((visa, index) => {
          return <VisaItem key={index} title={visa.name} files={visa.files} items={visa.values} />
        })}
      </Masonry>
    )
  }
}

export default Visas
